const settings = ['social', 'marketing', 'clienteling'] as const
const storeNames = [
  'clientelier',
  'fabric bash',
  'faherty brand',
  'guys and co',
  'ladder',
  'oneshop',
  'penelope t',
  'q clothier',
  'Scout & Mollys Plano',
  'Scout & Mollys (Annapolis, Mosaic, & Reston Stores)',
  "sharla's boutique",
  'tristan',
  'unode50',
] as const

const unoFrenchStores = ['Carrefour Laval'] as const
const unoSpanishStores = [
  'Plaza Carolina',
  'Plaza Del Caribe',
  'Plaza Del Sol',
  'Plaza Las Americas',
  'Puerto Rico Pop Up Plaza',
  'Pop Up Plaza Del Caribe',
] as const

export { settings, storeNames, unoFrenchStores, unoSpanishStores }
